import store from "../store";
import { APIService } from "./api";
const apiService = new APIService();

export class APIServiceBilling {
  getAccountBillingMethods() {
    var config = {
      url: "/account/billing",
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  getAccountBillingEntry(id) {
    var config = {
      url: "/account/billing/" + id,
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  createAccountBillingMethod(data) {
    var config = {
      url: "/account/billing",
      method: "post",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      },
      data: data
    };
    return apiService.api(config);
  }
}
